// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datePicker_kGGCR {
  display: inline-block;
  cursor: pointer;
  position: relative;
}

.input_zxHyS {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;


}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DashboardComponents/DatePicker/DatePicker.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;;;AAGb","sourcesContent":[".datePicker {\n  display: inline-block;\n  cursor: pointer;\n  position: relative;\n}\n\n.input {\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n  width: 100%;\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"datePicker": `datePicker_kGGCR`,
	"input": `input_zxHyS`
};
export default ___CSS_LOADER_EXPORT___;
